import { get } from '../helpers/http';
import * as actionTypes from '../consts/actionTypes';
import { ICountryCode } from '../interfaces';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { IState } from '../reducers';

interface IShipCriteria {
    shipCategory: number;
    shipType: number;
    sortString: string;
    company: number;
    limit: number;
    offset: number;
}

export const fetchShipPrices = (companyNid: number) => (dispatch, getState) => {
    const url = `${getState().pageData.appConfig.apiHost}/ships/prices/${companyNid}`;
    return get(url)
        .then((result) => {
            dispatch({
                type: actionTypes.updateShipOverviewPrices,
                payload: { prices: result, companyNid: companyNid },
            });
        })
        .catch((_) => []);
};

function newSearchRequestPayload(criteria: IShipCriteria, countryCode: string, apiHost: string) {
    const shipCategory =
        criteria.shipCategory || criteria.shipCategory === 0 ? `${criteria.shipCategory}` : '';
    const shipType = criteria.shipType ? `${criteria.shipType}` : '';
    const company = criteria.company ? `${criteria.company}` : '';

    const sortString = criteria.sortString || '';
    const limit = criteria.limit ? `&limit=${criteria.limit}` : '';

    return {
        meta: {
            shipCategory: criteria.shipCategory,
            shipType: criteria.shipType,
            company: criteria.company,
            sortString: criteria.sortString,
        },

        payload: get(
            `${apiHost}/ships/search?countryCode=${countryCode}` +
                (shipCategory && `&filterParams[shipCategory][]=${shipCategory}`) +
                (shipType && `&filterParams[shipType][]=${shipType}`) +
                (company && `&filterParams[company][]=${company}`) +
                `&sortString=${sortString}&offset=${criteria.offset}${limit}`,
        ),
    };
}

export const loadMore = (criteria: IShipCriteria) => (
    dispatch: Dispatch<AnyAction>,
    getState: () => IState,
) => {
    const { countryCode, apiHost } = getState().pageData.appConfig;
    const newSearchValues = newSearchRequestPayload(criteria, countryCode, apiHost);
    dispatch({
        type: actionTypes.loadMore,
        payload: newSearchValues.payload,
        meta: newSearchValues.meta,
    });
};

export const newSearch = (criteria: IShipCriteria) => (
    dispatch: Dispatch<AnyAction>,
    getState: () => IState,
) => {
    const { countryCode, apiHost } = getState().pageData.appConfig;
    const newSearchValues = newSearchRequestPayload(criteria, countryCode, apiHost);
    dispatch({
        type: actionTypes.newSearch,
        payload: newSearchValues.payload,
        meta: newSearchValues.meta,
    });
};

export const newSortSearch = (criteria: IShipCriteria) => (
    dispatch: Dispatch<AnyAction>,
    getState: () => IState,
) => {
    const { countryCode, apiHost } = getState().pageData.appConfig;
    const newSearchValues = newSearchRequestPayload(criteria, countryCode, apiHost);
    dispatch({
        type: actionTypes.newSortRequest,
        payload: newSearchValues.payload,
        meta: newSearchValues.meta,
    });
};
